import React from 'react';

export interface ArrowProps {
  color: string,
}

export const RightArrowInCircleFilled: React.FC<ArrowProps> = ({ color }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill={color} />
    <path
      d="M21.8333 16L10.1666 16"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 10.1667L21.8333 16.0001L16 21.8334"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

export const LeftArrowInCircleFilled: React.FC<ArrowProps> = ({ color }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill={color} />
    <path
      d="M10.1667 16H21.8334"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21.8333L10.1667 15.9999L16 10.1666"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

export const RightArrowInCircleLarge: React.FC<ArrowProps> = ({ color }) => (
  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.6667 54H63.3334"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54 44.6667L63.3333 54.0001L54 63.3334"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1" y="1" width="106" height="106" rx="53" stroke={color} strokeWidth="2" />
  </svg>

);

export const LeftArrowInCircleLarge: React.FC<ArrowProps> = ({ color }) => (

  <svg
    width="108"
    height="108"
    viewBox="0 0 108 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M63.3334 54H44.6667"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54 63.3333L44.6667 53.9999L54 44.6666"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="1" y="1" width="106" height="106" rx="53" stroke={color} strokeWidth="2" />
  </svg>
);

export const AngledArrowInCircleFilled: React.FC<ArrowProps & {arrowColor?: string}> = ({ color, arrowColor }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill={color} />
    <path
      d="M11.8755 20.1248L20.1251 11.8752"
      stroke={arrowColor || "var(--color-razem-700)"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.875 11.8752L20.1246 11.8752L20.1246 20.1248"
      stroke={arrowColor || "var(--color-razem-700)"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
